type Enum<Value extends string> = {
	[Key in Value]: Key;
};

export function makeEnum<const Value extends string>(values: readonly Value[]): Enum<Value> {
	const enumObject: Enum<Value> = {} as Enum<Value>;
	for (const value of values) {
		enumObject[value] = value;
	}
	return enumObject;
}
